var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup51(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 109,
    height: 77,
    viewBox: "0 0 109 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1253 -4939)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1254.5 4940.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,42V13.731A6.731,6.731,0,0,1,13.731,7h0a6.731,6.731,0,0,1,6.731,6.731V28.538H31.231A10.769,10.769,0,0,1,42,39.308V42",
    transform: "translate(28.5 28.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(0.5 0.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(22.038 0.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(43.577 0.5)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(0.5 19.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(22.038 19.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(43.577 19.346)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.692,
    cy: 2.692,
    r: 2.692,
    transform: "translate(0.5 38.192)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.192,12.885a2.692,2.692,0,1,1,0-5.385Z",
    transform: "translate(17.538 30.692)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,45A22.506,22.506,0,0,1,13.742,1.768,22.506,22.506,0,0,1,31.258,43.232,22.359,22.359,0,0,1,22.5,45Zm-.153-29.665a2.168,2.168,0,0,1,1.709.678,2.728,2.728,0,0,1,.6,1.862,3.638,3.638,0,0,1-.568,1.831,14.216,14.216,0,0,1-1.751,2.258l-5.749,6.128v2.417H28.768V27.664H21.127l4.041-4.26a15.069,15.069,0,0,0,2.344-3.186,6.008,6.008,0,0,0,.683-2.686,4.687,4.687,0,0,0-1.519-3.723,6.334,6.334,0,0,0-4.267-1.318,6.692,6.692,0,0,0-3.21.763,5.492,5.492,0,0,0-2.192,2.106,5.85,5.85,0,0,0-.775,2.965h3.541a3.277,3.277,0,0,1,.689-2.166A2.339,2.339,0,0,1,22.347,15.335Z",
    transform: "translate(1317 4971)",
    fill: "#761ccb"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup51);
export default __webpack_public_path__ + "static/media/Group51.56c8f24a.svg";
export { ForwardRef as ReactComponent };